import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ModalName } from "components/modal/types";
import { language } from "language/default";
import { openModal } from "store/modal";
export const InsEditJsonWidgetIcon = (props) => {
    const dispatch = useDispatch();
    const editEnabled = useSelector((state) => state.settings.current?.enableJSONEditing, isEqual);
    if (editEnabled) {
        return React.createElement("span", { className: "editConfig" },
            React.createElement(AuxButton, { type: AuxButtonTypeEnum.TERTIARY, label: "{ }", title: language.en.widget.editConfig, onMouseDown: () => dispatch(openModal({ content: { id: "edit-widget-json",
                        metadata: props,
                        modalName: ModalName.EditJsonWidget },
                    title: language.en.modal.editjsonWidget.title,
                    type: "action" })) }));
    }
    return React.createElement(React.Fragment, null);
};
